export default function (Component) {
Component.options.__title = "Action bar with back button, description and action buttons."
}